import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import ErrorIcon from '../../../assets/images/icon_error_messages.gif';
import Label from './common/label';

const Cpms = ({ labels, errors, touched, role }) => {
  const getFieldLabel = label =>
    [4, 11].includes(+role) ? label.replace('*', '') : label;
  return (
    <>
      <Label labelName={getFieldLabel(labels.CPMS_ID)} />
      <div
        style={{ position: 'relative' }}
        className={`input-container ${
          errors.cpmsId && touched.cpmsId ? 'error' : ''
        }`}
      >
        <Field
          placeholder={labels.PLACEHOLDER_CPMS_ID}
          className="select-style"
          name="cpmsId"
          type="text"
        />
        <>
          <div className="error_messages">
            <span className="frg-body-font-14px">{errors.cpmsId}</span>
          </div>
          <div id="username_error_icon" className="error_messages_icon">
            <img src={ErrorIcon} alt="error_icon" />
          </div>
        </>
      </div>
    </>
  );
};

Cpms.propTypes = {
  labels: PropTypes.isRequired,
  errors: PropTypes.isRequired,
  touched: PropTypes.func.isRequired,
  role: PropTypes.string.isRequired
};

export default Cpms;
